import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useI18nContext } from "@hopper-b2b/i18n";
import { PackageCarsSelectors } from "../../store";
import { usePackageCarAvailabilityLink } from "../PackageCarAvailabilityLink/hook";
import type { CarAvailabilityCardType } from "./CarAvailabilityCard";
import { CarsAvailabilitySelectors } from "~core-cars/store";
import {
  getBaggageQty,
  getVehicleClassLabelFromVehicle,
  getVehicleTransmissionLabel,
} from "~core-cars/utilities";

export const useCarAvailabilityCard = (props: CarAvailabilityCardType) => {
  const { car } = props;

  const { t } = useI18nContext();

  const searchDayCount = useSelector(
    CarsAvailabilitySelectors.getSearchDayCount
  );

  const packageStateByVehicleId = useSelector(
    PackageCarsSelectors.getPackageStateByVehicleId
  );

  const { goToPackageShop } = usePackageCarAvailabilityLink(
    car.vehicle.id,
    car.cancellationPolicy
  );

  // Use package total price if available, otherwise use the regular car price
  const packageState = packageStateByVehicleId?.[car.vehicle.id];
  const displayPrices =
    packageState?.price.incrementalChange ??
    packageState?.price.totalPrice ??
    props.car.totalCharge;

  return useMemo(
    () => ({
      context: {
        car,
        supplier: car.supplier,
        kind: getVehicleClassLabelFromVehicle(t, car.vehicle),
        name: car.vehicle.name,
        image: car.vehicle.images?.["original"],
        attributes: {
          passengersQuantity: car.vehicle.passengerQty,
          unlimitedMileage: car.hasUnlimitedMileage,
          baggageQuantity: getBaggageQty(car.vehicle),

          transmissionType: getVehicleTransmissionLabel(
            t,
            car.vehicle.transmissionType
          ),
          airConditioning: car.vehicle.airConditioning,
        },
        cancellationPolicy: car.cancellationPolicy,
        prices: displayPrices,
        searchDayCount,
        pickup: car.pickUp,
      },
      handlers: {
        goToShop: goToPackageShop,
      },
    }),
    [car, t, displayPrices, searchDayCount, goToPackageShop]
  );
};
